import axios from 'axios';
import router from '@/router';
import qs from 'qs';
import { getCookie } from '../utils/tools';
// axios 默认配置
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.headers['x-client'] = process.env.xClient || 'location-store-assistant-h5';
axios.defaults.headers['x-client-version'] = process.env.xClientVersion || '1.2';
axios.defaults.headers['clientKey'] = 1000114;
axios.defaults.timeout = 30000; // 设置30s为超时
if (process.env.CUSTOMIZED_PROJECT) {
    axios.defaults.headers['x-private-project'] = process.env.CUSTOMIZED_PROJECT;
}
else if (getCookie('test-customized-project')) { // 集成和测试环境用
    if (process.env.NODE_TYPE === 'ie' || process.env.NODE_TYPE === 'te') {
        axios.defaults.headers['x-private-project'] = getCookie('test-customized-project');
    }
}
// 存储路由跳转时，需要cancel的接口
var requestMap = new Map();
var instance = axios.create();
/**
 * 请求拦截
 */
instance.interceptors.request.use(function (config) {
    var method = config.method;
    if (method === 'get') {
        // https://juejin.cn/post/6995362880996507656
        // 如果是get请求，且params是数组类型如arr=[1,2]，则转换成arr=1&arr=2
        config.paramsSerializer = function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' });
        };
    }
    if (config.cancelToken) {
        var source = axios.CancelToken.source();
        config.axiosKey = config.url.split('?')[0];
        config.cancelToken = source.token;
        // 如果存在就未完结的就cancel
        if (requestMap.has(config.axiosKey)) {
            requestMap.get(config.axiosKey).cancel();
        }
        requestMap.set(config.axiosKey, source);
    }
    return config;
});
/**
 * 结果拦截
 */
instance.interceptors.response.use(function (response) {
    var axiosKey = response.config.axiosKey;
    requestMap.delete(axiosKey);
    return response;
});
setTimeout(function () {
    router.beforeEach(function (to, from, next) {
        // 遍历全部取消
        if (requestMap.size > 0) {
            requestMap.forEach(function (item, key) {
                item.cancel();
                requestMap.delete(key);
            });
        }
        next();
    });
});
export default instance;
